<p-dialog
  #modal
  modal="true"
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header" show-close="true">
    <h4>{{ 'events.new.component.title' | translate | titlecase }}</h4>
  </ng-template>
  <div class="container-fluid">
    <div class="form-horizontal">
      <form #newEventForm="ngForm">
        <div class="form-group">
          <div class="col-xs-12">
            <input
              type="text"
              class="form-control"
              name="eventName"
              placeholder="{{ 'events.new.component.event-name-placeholder' | translate }}"
              [(ngModel)]="eventNewParams.EventName"
              required
            />
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-12">
            <ul class="list-inline stack-mobile">
              <li>
                <label>
                  {{ 'events.new.component.event-start-date-label' | translate }}
                </label>
                <div class="wl-give-calendar-right-padding">
                  <wl-date-selector
                    name="startDate"
                    [(ngModel)]="eventNewParams.StartDate"
                    (onDateChanged)="startDateChanged($event)"
                  ></wl-date-selector>
                </div>
              </li>
              <li>
                <label>
                  {{ 'events.new.component.event-start-time-label' | translate }}
                </label>
                <br />
                <wl-time-selector inputCssClass="form-control" name="startTime" [(ngModel)]="eventNewParams.StartTime"> </wl-time-selector>
              </li>
            </ul>
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-12">
            <ul class="list-inline stack-mobile">
              <li>
                <label>
                  {{ 'events.new.component.event-end-date-label' | translate }}
                </label>
                <div class="wl-give-calendar-right-padding">
                  <wl-date-selector
                    name="endDate"
                    [(ngModel)]="eventNewParams.EndDate"
                    [minDate]="eventNewParams.StartDate"
                  ></wl-date-selector>
                </div>
              </li>
              <li>
                <label>
                  {{ 'events.new.component.event-end-time-label' | translate }}
                </label>
                <br />
                <br />
                <wl-time-selector inputCssClass="form-control" name="endTime" [(ngModel)]="eventNewParams.EndTime"></wl-time-selector>
              </li>
            </ul>
          </div>
        </div>
      </form>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger" [hidden]="!errorMessage">
      {{ errorMessage }}
    </div>
    <wl-busy [show]="saving"></wl-busy>
    <button
      pButton
      type="button"
      class="btn btn-primary"
      (click)="createEvent($event)"
      [disabled]="!newEventForm.valid || saving"
      icon="pi pi-save"
    >
      <span [hidden]="saving">{{ 'common.save' | translate | titlecase }}</span>
      <span [hidden]="!saving">{{ 'common.saving' | translate | titlecase }}</span>
    </button>
    <wl-busy [show]="saving"></wl-busy>
    <button pButton type="button" class="btn btn-secondary" (click)="newCancel()" [disabled]="saving" icon="pi pi-ban">
      {{ 'common.cancel' | translate | titlecase }}
    </button>
  </ng-template>
</p-dialog>
